<div class="card">
  <div class="sub-component-placeholder">
    <div class="sub-component-container" >
      <div class="sub-title">{{"general-advice-advice-given-title" | translate}}</div>
        <app-text-box [name]="'general-advice-advice-given-label' | translate"
                      [maxTextLength]="1000"
                        [required]="false"
                      [(value)]="generalAdvice.adviceGiven">
        </app-text-box>
    </div>
  </div>
  <div class="sub-component-placeholder">
    <div class="col-5 p-0">
      <app-sub-commitment-type
        [(commitmentType)]="generalAdvice.commitmentType"
        [serviceOrderType]="serviceOrderType"
        [caseId]="caseId"
        ></app-sub-commitment-type>
      </div>
  </div>
  <div class="sub-component-placeholder">
    <div class="col-5 p-0">
      <app-input-date-time
        [name]="'general-advice-start-date' | translate"
        (dateChange)="startDateChange($event)"
        [required]="true"
        [withImage]="true"
        [date]="generalAdvice.startDate"
        [timeZone]="'secca'"
      >
      </app-input-date-time>
    </div>
</div>
</div>
